<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <!-- add 2 next lines by Abdelmomen -->
        <ValidationObserver v-slot="{ passed, failed }">
          <form>
            <modal
              v-if="showModalsorce"
              @close="
                showModalsorce = false;
                SourceT = Source;
              "
            >
              <h3 slot="header"></h3>
              <div slot="body">
                <div
                  class="md-layout-item md-size-100 md-small-size-100 ml-15 mt-25"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>سبب رفض خصم الإجازة</label>
                    <md-input v-model="note"></md-input>
                  </md-field>
                </div>
              </div>
              <div slot="footer">
                <md-button
                  style="margin-right: 32px"
                  @click="unconfirm"
                  class="md-success"
                  >متابعة
                </md-button>

                <md-button @click="showModalsorce = false" class="md-danger"
                  >الغاء</md-button
                >
              </div>
            </modal>
          </form>
        </ValidationObserver>

        <!-- Excuse Modal Component -->
        <ExcuseModal
          :show="showExcuseModal"
          :rowData="selectedRowForExcuse"
          :loading="excuseLoading"
          @close="closeExcuseModal"
          @confirm="handleExcuseConfirm"
          @validation-error="handleExcuseValidationError"
        />

        <form>
          <md-card class="p-25">
            <md-card-content>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                >
                  <model-list-select
                    class="input-must-rtl"
                    :list="employees"
                    v-model="EmployeeId"
                    option-value="key"
                    option-text="value"
                    placeholder="الموظف"
                  >
                  </model-list-select>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="DateFrom">
                    <label class="mr-28">من تاريخ</label>
                  </md-datepicker>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="DateTo">
                    <label class="mr-28">الى تاريخ</label>
                  </md-datepicker>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mtb-25"
                >
                  <model-list-select
                    class="input-must-rtl"
                    :list="departments"
                    v-model="RequesterDeparmentId"
                    option-value="id"
                    option-text="name"
                    placeholder="الوحدة التنظيمية"
                  >
                  </model-list-select>
                </div>

                <div class="md-layout-item md-size-100 mt-25 center-content">
                  <md-button @click="Search" class="md-success btn_nanosoft"
                    >بحث</md-button
                  >
                  <md-button
                    class="md-warning btn_nanosoft"
                    :disabled="printLoading"
                    @click="printReport"
                  >
                    <md-icon>picture_as_pdf</md-icon>
                    طباعة PDF
                  </md-button>
                </div>

                <div class="md-layout-item md-size-100 mtb-25 center-content">
                  <md-button
                    @click="confirm"
                    :disabled="isLoading"
                    class="md-primary btn_nanosoft"
                    >اعتماد لكافة الموظفين</md-button
                  >
                  <md-button
                    @click="unconfirm"
                    :disabled="isLoading"
                    class="md-black btn_nanosoft"
                    >إلغاء اعتماد لكافة الموظفين
                  </md-button>
                  <md-button
                    class="md-primary btn_nanosoft"
                    :disabled="isLoading"
                    @click="confirmEmployee"
                  >
                    اعتماد للموظف
                  </md-button>
                  <md-button
                    class="md-black btn_nanosoft"
                    :disabled="isLoading"
                    @click="unConfirmEmployee"
                  >
                    إلغاء اعتماد للموظف
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </div>

    <!-- <md-card>
            <md-card-content> -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      filename="Social Solidarity"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a2"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      :html-to-pdf-options="{
        margin: [10, 10, st == 8 ? '5' : '5', 10],
        filename: stName,
        jsPDF: {
          format: `a2`,
          orientation: `portrait`,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
          dpi: 300,
          letterRendering: true,
        },
      }"
      ref="html2Pdf"
      @beforeDownload="beforeDownload($event)"
      @progress="progressPdf"
      @startPagination="startPagination"
      @hasPaginated="hasPaginated"
      @hasDownloaded="hasDownloaded"
    >
      <section class="pdf-container d-flex" slot="pdf-content">
        <!-- PDF Content Here -->

        <Timesheet
          :items="items"
          :alldata="allData"
          :date="dateF"
          :pathLogo="pathLogo"
        />
      </section>
    </vue-html2pdf>

    <!-- </md-card-content>
        </md-card> -->

    <div class="md-layout-item">
      <div class="employee-nav-wrapper">
        <md-button
          class="md-primary md-raised employee-nav-btn"
          :disabled="isBackDisabled"
          @click="goToPreviousEmployee"
        >
          <md-icon>chevron_right</md-icon>
          السابق
        </md-button>

        <md-button
          class="md-primary md-raised employee-nav-btn"
          :disabled="isNextDisabled"
          @click="goToNextEmployee"
        >
          التالي
          <md-icon>chevron_left</md-icon>
        </md-button>
      </div>

      <md-card>
        <md-card-content>
          <md-progress-bar
            v-if="isLoading"
            md-mode="indeterminate"
          ></md-progress-bar>

          <div class="md-layout flex-content-left">
            <div class="md-size-15 md-layout-item mt-25">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option value="25">25</md-option>
                      <md-option value="50">50</md-option>
                      <md-option value="75">75</md-option>
                      <md-option value="100">100</md-option>
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row
              slot="md-table-row"
              :style="{
                backgroundColor:
                  item.workTime == item.delayTime && item.workTime > '00:00:00'
                    ? '#fcf8de'
                    : '',
              }"
              slot-scope="{ item }"
            >
              <md-table-cell md-label="التاريخ">{{
                convert(item.date)
              }}</md-table-cell>

              <md-table-cell md-label="اليوم">{{ item.day }}</md-table-cell>

              <md-table-cell md-label="الحالة">{{ item.status }}</md-table-cell>

              <md-table-cell md-label="حضور متأخر ؟">{{
                item.isStartedLateString
              }}</md-table-cell>

              <md-table-cell md-label="خروج مبكر ؟">{{
                item.isFinishedEarlyString
              }}</md-table-cell>

              <md-table-cell md-label="نوع اليوم">{{
                item.dayTypeString
              }}</md-table-cell>

              <md-table-cell md-label="وقت الدخول">{{
                item.startedAt
              }}</md-table-cell>

              <md-table-cell md-label="وقت الخروج">{{
                item.finishedAt
              }}</md-table-cell>

              <md-table-cell md-label="مدة العمل">{{
                item.workTime
              }}</md-table-cell>

              <md-table-cell class="text-success" md-label="مدة الحضور">
                {{ formatTime(item.presentTime) }}
              </md-table-cell>

              <md-table-cell class="text-danger" md-label="مدة التأخير">{{
                formatTime(item.delayTime)
              }}</md-table-cell>

              <md-table-cell class="text-primary" md-label="مدة الإضافي">{{
                formatTime(item.overtime)
              }}</md-table-cell>

              <md-table-cell md-label="معتمد">
                {{ item.isConfirmed == true ? "نعم" : "لا" }}
              </md-table-cell>

              <md-table-cell md-label="الإجراءات">
                <md-button
                  class="md-just-icon md-info md-simple"
                  @click="openExcuseModal(item)"
                >
                  <md-icon>visibility</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <!-- <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div> -->
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import env from "../../../../../env";
import Modal from "../modal.vue";
import VueHtml2pdf from "vue-html2pdf";
import Timesheet from "../../../../components/Reports/Timesheet.vue";
import ExcuseModal from "./ExcuseModal.vue";
import moment from "moment";

export default {
  async created() {
    this.init();
  },
  components: {
    Pagination,
    ModelListSelect,
    Modal,
    VueHtml2pdf,
    Timesheet,
    ExcuseModal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
    currentEmployeeIndex() {
      return this.employees.findIndex((e) => e.key === this.EmployeeId);
    },
    areFieldsFilled() {
      return this.EmployeeId && this.DateFrom && this.DateTo;
    },
    isBackDisabled() {
      return !this.areFieldsFilled || this.currentEmployeeIndex <= 0;
    },
    isNextDisabled() {
      return (
        !this.areFieldsFilled ||
        this.currentEmployeeIndex >= this.employees.length - 1
      );
    },
  },
  data() {
    return {
      isLoading: false,
      printLoading: false,
      stName: "جدول الحضور والإنصراف",
      pathLogo: "",
      dateF: "",
      allData: "",
      items: "",
      errorMessage: "",
      duration: "",
      vacationBalance: "",
      EmployeeId: null,
      RequesterEmployeeId: "",
      RequesterDeparmentId: "",
      VactionTypeId: "",
      DateFrom: null,
      DateTo: null,
      vacationType: "",
      employees: [],
      departments: [],
      tableData: [],
      idTable: "",
      note: "",
      showModalsorce: false,

      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null,
      currentSort: "Titel",
      currentSortOrder: "asc",

      // Excuse Modal data
      showExcuseModal: false,
      selectedRowForExcuse: null,
      excuseLoading: false,
    };
  },
  methods: {
    goToNextEmployee() {
      if (this.isNextDisabled) return;
      this.EmployeeId = this.employees[this.currentEmployeeIndex + 1].key;
      this.Search();
    },
    goToPreviousEmployee() {
      if (this.isBackDisabled) return;
      this.EmployeeId = this.employees[this.currentEmployeeIndex - 1].key;
      this.Search();
    },
    validateEmployeeHandler() {
      if (!this.EmployeeId) {
        this.notifyVue("top", "center", "danger", "عفواً، الرجاء اختيار موظف ");

        return false;
      }

      if (!this.DateFrom || !this.DateTo) {
        this.notifyVue("top", "center", "danger", "برجاء ادخال التاريخ اولا");

        return false;
      }

      return true;
    },
    async confirmEmployee() {
      try {
        this.isLoading = true;
        const isValidate = this.validateEmployeeHandler();

        if (!isValidate) {
          return;
        }

        let schema = {
          from: moment(this.DateFrom).format("YYYY-MM-DD"),
          to: moment(this.DateTo).format("YYYY-MM-DD"),
        };

        let { data } = await this.$axios.post(
          `${env.HR()}/api/hr/Timesheet/${this.EmployeeId}`,
          schema
        );

        if (data.message) {
          this.notifyVue("top", "center", "success", data.message);
        }
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
    async unConfirmEmployee() {
      try {
        this.isLoading = true;
        const isValidate = this.validateEmployeeHandler();

        if (!isValidate) {
          return;
        }

        let schema = {
          from: moment(this.DateFrom).format("YYYY-MM-DD"),
          to: moment(this.DateTo).format("YYYY-MM-DD"),
        };

        let { data } = await this.$axios.post(
          `${env.HR()}/api/hr/Timesheet/delete/${this.EmployeeId}`,
          schema
        );

        console.warn("data", data);

        if (data.message) {
          this.notifyVue("top", "center", "success", data.message);
        }
      } catch (error) {
        this.notifyVue("top", "center", "danger", error.response.data.message);
        // console.warn("error", error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
    async generateReport() {
      this.SearchPrint();
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .set({ pagebreak: { avoid: "tr" } })
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          pdf.setFont("Amiri-Regular");
          // pdf.setR2L(true);
          pdf.setLanguage("ar-KW");
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(30);
            pdf.setTextColor(150);
            // pdf.text(
            //   this.companyName,
            //   pdf.internal.pageSize.getWidth() * 0.77,
            //   40,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   this.companyDesc,
            //   pdf.internal.pageSize.getWidth() * 0.63,
            //   55,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.1,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.5,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.9,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
          }
        })
        .save();
    },

    formatTime(time) {
      if (!time) return time;
      return time.split(".")[0];
    },

    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      } catch (error) {}
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    "pagination.currentPage"() {
      this.Search();
    },

    async Search() {
      try {
        this.isLoading = true;
        this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.EmployeeId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار موظف "
          );
        }

        if (this.DateFrom == null) {
          this.DateFrom = null;
        } else {
          this.DateFrom = moment(this.DateFrom).format("YYYY-MM-DD");
        }
        if (this.DateTo == null) {
          this.DateTo = null;
        } else {
          this.DateTo = moment(this.DateTo).format("YYYY-MM-DD");
        }

        let result = await axios.get(
          `${env.HR()}/api/hr/Timesheet/search?EmployeeId=${
            this.EmployeeId
          }&From=${this.DateFrom}&To=${this.DateTo}&DepartmentId=${
            this.RequesterDeparmentId
          }&PageSize=${this.pagination.perPage}&currentPage=${
            this.pagination.currentPage
          }`,

          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.tableData = result.data.data;
      } catch (error) {
        this.message(error);
      } finally {
        this.isLoading = false;
      }
    },

    // التاريخ ليه أربع حالات وقت الطباعة: فاضي، أو Date من التقويم، أو نص
    // "YYYY-MM-DD" بعد ما البحث/الاعتماد يحوّله في مكانه، أو موديل لسه متأخر عن
    // الخانة. الأربعة بيطلّعوا نفس الصيغة، والفاضي بيتشال من الـ query string.
    toPrintDate(rawDate) {
      if (!rawDate) {
        return undefined;
      }

      const parsed = moment(rawDate);

      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : undefined;
    },

    triggerFileDownload(blob, fileName) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    // النص الثابت مكتوب هنا عمدًا ومش مأخوذ من stName: إملاؤه مختلف («الإنصراف»
    // بهمزة) وهو مربوط بمسار الطباعة القديم.
    buildPrintFileName(employee) {
      const baseName = "جدول الحضور والانصراف";
      const employeeName = (employee ? employee.value : "")
        .replace(/[/\\:*?"<>|]/g, "")
        .trim();

      return employeeName
        ? `${baseName} - ${employeeName}.pdf`
        : `${baseName}.pdf`;
    },

    async printReport() {
      // الحارس متزامن عشان ضغطتين في نفس الـ tick يعدّي منهم واحدة بس —
      // ربط :disabled لوحده بيتحدّث بعد ما الهاندلر يبتدي.
      if (this.printLoading) {
        return;
      }

      try {
        // التعيين وكل الـ early returns جوه الـ try عشان finally تفكّ المؤشر
        // في كل المسارات، وإلا الزر يفضل متعطّل لباقي الجلسة.
        this.printLoading = true;

        if (!this.EmployeeId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار موظف "
          );
        }

        // اللقط قبل أول await: الشاشة بتفضل شغّالة أثناء الطلب، وأزرار
        // «التالي»/«السابق» بتغيّر EmployeeId فورًا.
        const employeeId = this.EmployeeId;
        const departmentId = this.RequesterDeparmentId;
        const fileName = this.buildPrintFileName(
          this.employees.find((emp) => emp.key === employeeId)
        );

        const { data: pdfBytes } = await this.$axios.get(
          "/api/hr/Timesheet/search/report",
          {
            params: {
              EmployeeId: employeeId,
              From: this.toPrintDate(this.DateFrom),
              To: this.toPrintDate(this.DateTo),
              // أكسيوس 0.19 بيشيل null/undefined بس، والنص الفاضي بيعدّي
              // وبيطلع `DepartmentId=` في الـ URL.
              DepartmentId: departmentId === "" ? undefined : departmentId,
            },
            responseType: "blob",
          }
        );

        this.triggerFileDownload(
          new Blob([pdfBytes], { type: "application/pdf" }),
          fileName
        );
      } catch (error) {
        // catch خاص بالطباعة: message(error) بينفجر لما جسم الرد يبقى Blob،
        // لأنه بيقرا .message و.errors اللي مش موجودين عليه.
        this.notifyVue("top", "center", "danger", "حدث خطأ في تنزيل التقرير");
      } finally {
        this.printLoading = false;
      }
    },

    async SearchPrint() {
      try {
        this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.dateF) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار  تاريخ الطباعة "
          );
        }

        let d = new Date(this.dateF);
        let Year = d.getFullYear();
        let Month = d.getMonth() + 1;

        let result = await axios.get(
          `${env.HR()}/api/hr/Timesheet/Report?Year=${Year}&Month=${Month}&EmployeeId=${
            this.EmployeeId
          }&DepartmentId=${this.RequesterDeparmentId}`,

          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.allData = result.data.data;
        this.items = result.data.data.items;
        this.$refs.html2Pdf.generatePdf();
      } catch (error) {
        this.message(error);
      }
    },

    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(`${env.HR()}/api/hr/Timesheet`, {
          headers: { Authorization: "Bearer " + token },
        });

        this.employees = result.data.data.employees;
        this.departments = result.data.data.departments;
        // let resultLogo = await axios.get(`${env.HR()}/api/company-info/GetLogoPath`, {
        //     headers: { Authorization: "Bearer " + token },
        // });
        // this.pathLogo = resultLogo.data.data.path;
      } catch (error) {
        this.message(error);
      }
    },

    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    async confirm() {
      try {
        this.isLoading = true;
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.DateFrom || !this.DateTo) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء تحديد التاريخ من  الى "
          );
        }

        if (this.DateFrom == null) {
          this.DateFrom = null;
        } else {
          this.DateFrom = moment(this.DateFrom).format("YYYY-MM-DD");
        }
        if (this.DateTo == null) {
          this.DateTo = null;
        } else {
          this.DateTo = moment(this.DateTo).format("YYYY-MM-DD");
        }

        let schema = {
          From: this.DateFrom,
          To: this.DateTo,
        };

        let result = await axios.post(`${env.HR()}/api/hr/Timesheet`, schema, {
          headers: { Authorization: "Bearer " + token },
        });

        return this.notifyVue("top", "center", "success", result.data.message);
      } catch (error) {
        console.warn("error", error);
        this.message(error);
      } finally {
        this.isLoading = false;
      }
    },

    async unconfirm() {
      try {
        this.isLoading = true;
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.DateFrom || !this.DateTo) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء تحديد التاريخ من  الى "
          );
        }

        if (this.DateFrom == null) {
          this.DateFrom = null;
        } else {
          this.DateFrom = moment(this.DateFrom).format("YYYY-MM-DD");
        }
        if (this.DateTo == null) {
          this.DateTo = null;
        } else {
          this.DateTo = moment(this.DateTo).format("YYYY-MM-DD");
        }

        let schema = {
          From: this.DateFrom,
          To: this.DateTo,
        };
        let result = await axios.post(
          `${env.HR()}/api/hr/Timesheet/delete`,
          schema,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        return this.notifyVue("top", "center", "success", result.data.message);
      } catch (error) {
        this.message(error);
      } finally {
        this.isLoading = false;
      }
    },

    tracking() {
      this.showModalsorce = true;
      this.note = "";
    },

    handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });

      this.idTable = item.id;
      this.RequesterEmployeeId = item.requesterEmployeeId;
      this.RequesterDeparmentId = item.requesterDepartmentId;
      this.VactionTypeId = item.typeId;
      this.DateFrom = new Date(item.from);
      this.DateTo = new Date(item.to);
    },

    openExcuseModal(item) {
      this.selectedRowForExcuse = item;
      this.showExcuseModal = true;
    },

    closeExcuseModal() {
      this.showExcuseModal = false;
      this.selectedRowForExcuse = null;
    },

    handleExcuseValidationError(message) {
      this.notifyVue("top", "center", "warning", message);
    },

    async handleExcuseConfirm({ excuseType, rowData }) {
      try {
        this.excuseLoading = true;
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let schema = {
          EmployeeId: rowData.employeeId,
          shiftId: rowData.shiftId,
          Type: parseInt(excuseType),
          Date: moment(rowData.date).format("YYYY-MM-DD[T]HH:mm:ss"),
          CalculationMechanism: "day",
          ToDate: moment(rowData.date).format("YYYY-MM-DD[T]HH:mm:ss"),
          Note: null,
          // DepartmentId: rowData.departmentId,
          status: true,
        };

        await axios.post(`${env.HR()}/api/Excuses`, schema, {
          headers: { Authorization: "Bearer " + token },
        });

        this.notifyVue("top", "center", "success", "تم إنشاء العذر بنجاح");
        this.closeExcuseModal();
        this.Search();
      } catch (error) {
        this.message(error);
      } finally {
        this.excuseLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.employee-nav-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.employee-nav-btn {
  min-width: 120px;
}
</style>
